<template>
  <div>
    编辑/添加合作伙伴
    <div class="input-wrap">
      <label>公司名称</label>
      <el-input
        v-model="info.name"
        placeholder="请输入标题"
        class="sort_input"
      ></el-input>
    </div>
    <div class="input-wrap">
      <label>权重</label>
      <el-input
        type="number"
        v-model="info.sort"
        placeholder="0～99,越大越靠前"
        class="sort_input"
      ></el-input>
    </div>
    <div class="img-wrap">
      <label>图片</label>
      <div class="m-upload">
        <imageUpload v-model="icon" :limit="1" />
        <p>pc端图片(尺寸: 1920*616)</p>
      </div>
      <div class="m-upload">
        <imageUpload v-model="h5_icon" :limit="1" />
        <p>h5端图片(尺寸: 750*784)</p>
      </div>
    </div>
    <div class="btn-wrap">
      <el-button type="primary" class="confirmBtn" @click="confirmClick"
        >保存</el-button
      >
      <el-button @click="cancelClick">取消</el-button>
    </div>
  </div>
</template>

<script>
import imageUpload from "@/components/ImageUpload";
import { getPartnerDetail, addPartner, editPartner } from "@/api/partner";

export default {
  name: "messagepush",
  data() {
    return {
      info: {
        sort: "",
        icon: "",
        h5_icon: "",
      },
      icon: [],
      h5_icon: [],
      type: "add",
    };
  },
  components: {
    imageUpload,
  },
  mounted() {
    let uuid = this.$route.query.uuid;
    if (uuid) {
      this._getPartnerDetail(uuid);
      this.type = "edit";
    }
  },
  methods: {
    async confirmClick() {
      this.info.icon = this.icon.join();
      this.info.h5_icon = this.h5_icon.join();
      const { name, sort, icon, h5_icon } = this.info;
      if (!name) {
        this.$message("公司名称不能为空");
        return;
      }
      if (!sort) {
        this.$message("权重不能为空");
        return;
      }
      if (+sort < 0 || +sort > 99 || sort % 1 !== 0) {
        this.$message("权重必须为0～99之间的整数");
        return;
      }
      if (!icon) {
        this.$message("请上传pc端图片");
        return;
      }
      if (!h5_icon) {
        this.$message("请上传h5端图片");
        return;
      }
      if (this.type === "add") {
        const { status } = await addPartner(this.info);
        if (status === 200) this.$router.go(-1);
      } else if (this.type === "edit") {
        const { status } = await editPartner(this.info);
        if (status === 200) this.$router.go(-1);
      }
    },
    cancelClick() {
      this.$router.go(-1);
    },
    async _getPartnerDetail(uuid) {
      const { status, data } = await getPartnerDetail(uuid);
      if (status !== 200) return;
      this.info = data;
      this.icon = [data.icon];
      this.h5_icon = [data.h5_icon];
    },
  },
};
</script>

<style lang="less" scoped>
.input-wrap {
  margin-top: 30px;
  .sort_input {
    width: 300px;
  }
}
label {
  display: block;
  margin-bottom: 10px;
}
.img-wrap {
  margin-top: 30px;
}
.btn-wrap {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 30px;
  .confirmBtn {
    margin-right: 50px;
  }
}
.m-upload {
  p {
    font-size: 12px;
    margin-top: 10px;
    padding-left: 60px;
  }
}
</style>
